import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Selector de objetivos (y sedes) a los que un usuario "cliente" puede
 * acceder desde el portal — solo lectura, acotado. Si no se marca ninguna
 * sede específica de un objetivo, se entiende "todas las sedes" de ese
 * objetivo (mismo criterio que usa el backend).
 */
export function ClientAccessPicker({ clients, value, onChange }) {
  const [sitesByClient, setSitesByClient] = useState({});

  useEffect(() => {
    (async () => {
      const map = {};
      for (const c of clients) {
        try { const { data } = await api.get(`/clients/${c.id}/sites`); map[c.id] = data; }
        catch { map[c.id] = []; }
      }
      setSitesByClient(map);
    })();
  }, [clients]);

  const entryFor = (cid) => value.find((e) => e.client_id === cid);

  const toggleClient = (cid) => {
    const exists = entryFor(cid);
    if (exists) onChange(value.filter((e) => e.client_id !== cid));
    else onChange([...value, { client_id: cid, site_ids: [] }]);
  };

  const toggleSite = (cid, sid) => {
    onChange(value.map((e) => {
      if (e.client_id !== cid) return e;
      const has = e.site_ids.includes(sid);
      return { ...e, site_ids: has ? e.site_ids.filter((s) => s !== sid) : [...e.site_ids, sid] };
    }));
  };

  return (
    <div data-testid="client-access-picker" style={{ border: "1px solid var(--invict-bone-3)", borderRadius: 4, padding: 10, maxHeight: 220, overflowY: "auto" }}>
      {clients.length === 0 && <div style={{ fontSize: 12, color: "var(--invict-text-muted)" }}>No hay objetivos creados todavía.</div>}
      {clients.map((c) => {
        const entry = entryFor(c.id);
        const sites = sitesByClient[c.id] || [];
        return (
          <div key={c.id} style={{ marginBottom: 8 }}>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
              <input type="checkbox" checked={!!entry} onChange={() => toggleClient(c.id)} data-testid={`client-access-toggle-${c.id}`} />
              {c.name}
            </label>
            {entry && sites.length > 0 && (
              <div style={{ marginLeft: 26, marginTop: 4, display: "flex", flexDirection: "column", gap: 3 }}>
                <div style={{ fontSize: 10, color: "var(--invict-text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                  {entry.site_ids.length === 0 ? "Todas las sedes" : "Sedes seleccionadas"}
                </div>
                {sites.map((s) => (
                  <label key={s.id} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, cursor: "pointer" }}>
                    <input type="checkbox" checked={entry.site_ids.includes(s.id)} onChange={() => toggleSite(c.id, s.id)} data-testid={`client-access-site-${s.id}`} />
                    {s.name}
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
